export const styles = {
  delete: {
    color: 'common.red',
  },
};
